(function () {
  'use strict';

  angular
    .module('procedureModule')
    .directive('prcMarkdownToolbar', directive);

  directive.$inject = [];

  function directive() {
    return {
      scope: {
        inputElementSelector: '@',
        lang: '@',
        sectionBlock: '=',
        procedure: '=',
        sectionBlockLookupAttributes: '&lookupAttributes',
        sectionBlockParticipants: '&participants',
        getBusinessUnitInsertedFunc: '&',
        getCommitteeInsertedFunc: '&',
        getCorpRoleInsertedFunc: '&',
        getFootnoteInsertedFunc: '&',
        getGlossaryTermInsertedFunc: '&',
        getIAMSystemInsertedFunc: '&',
        getImageInsertedFunc: '&',
        getProcedureInsertedFunc: '&',
        getResponsibilityInsertedFunc: '&',
        getSectionInsertedFunc: '&',
        getUrlInsertedFunc: '&'
      },
      restrict: 'E',
      templateUrl: require('./prcMarkdownToolbar.tpl.html'),
      controller: ['$scope', '$timeout', 'modalService', 'attachmentService', 'procedureService', 'responsibilityService',
        function ($scope, $timeout, modalService, attachmentService, procedureService, responsibilityService) {
          var inputElement = document.querySelector($scope.inputElementSelector);

          // Update inputElement pointer when selector changes
          $scope.$watch('inputElementSelector', function (newVal) {
            inputElement = document.querySelector(newVal);
          });

          $scope.sectionBlockLookupAttributes = $scope.sectionBlockLookupAttributes();

          // Get the functions to insert Procedure/Section which returns null if no permissions
          $scope.onBusinessUnitInserted = $scope.getBusinessUnitInsertedFunc();
          $scope.onCommitteeInserted = $scope.getCommitteeInsertedFunc();
          $scope.onCorpRoleInserted = $scope.getCorpRoleInsertedFunc();
          $scope.onFootnoteInserted = $scope.getFootnoteInsertedFunc();
          $scope.onGlossaryTermInserted = $scope.getGlossaryTermInsertedFunc();
          $scope.onIAMSystemInserted = $scope.getIAMSystemInsertedFunc();
          $scope.onImageInserted = $scope.getImageInsertedFunc();
          $scope.onProcedureInserted = $scope.getProcedureInsertedFunc();
          $scope.onResponsibilityInserted = $scope.getResponsibilityInsertedFunc();
          $scope.onSectionInserted = $scope.getSectionInsertedFunc();
          $scope.onUrlInserted = $scope.getUrlInsertedFunc();

          // Insert Image
          $scope.insertImage = function () {
            var title = getSelectedText();

            var modal = modalService.displayTemplateModal(
              'Upload an Image',
              require('./referenceType/prcImageUpload.modal.tpl.html'),
              {
                attachment: {
                  title: title,
                  validationTitle: title,
                  file: null,
                  uploadedFile: null
                },
                acceptedFiles: '.png,.jpg,.jpeg, image/png,image/jpeg,image/pjpeg',
                onTitleChanged: function (attachment) {
                  attachment.validationTitle = attachment.title ? attachment.title.trim() : null;
                },
                onFileAdded: function (file) {
                  var scope = this;
                  attachmentService
                    .uploadImage(file)
                    .then(function (file) {
                      if (file.messageSeverity && file.messageSeverity === 'Error') {
                        scope.attachment.file = null;
                        scope.attachment.uploadedFile = null;
                      } else {
                        scope.attachment.uploadedFile = file;
                      }
                    }, function () {
                      scope.attachment.file = null;
                      scope.attachment.uploadedFile = null;
                    });
                }
              },
              function (scope) {
                if (scope.attachment.uploadedFile && scope.attachment.title) {

                  scope.attachment.title = scope.attachment.title.trim();
                  var imageMarkdown = getMarkdownForImage(scope.attachment.uploadedFile, scope.attachment.title);
                  insertNewMarkdown(imageMarkdown);

                  $scope.onImageInserted({
                    uploadedFile: scope.attachment.uploadedFile,
                    title: scope.attachment.title,
                    content: inputElement.value
                  });

                  modal.$promise.then(modal.hide);
                }
              }
            );
          };

          // Insert URL
          $scope.insertUrl = function () {
            var title = getSelectedText();
            var modal = modalService.displayTemplateModal(
              'Add an URL',
              require('./referenceType/prcURL.modal.tpl.html'),
              {
                urlRef: {
                  TitleEN: title,
                  Url: null
                }
              },
              function (scope) {
                if (scope.urlRef.Url && scope.urlRef.TitleEN) {
                  var urlMarkdown = getMarkdownForUrl(scope.urlRef.Url, scope.urlRef.TitleEN);
                  insertNewMarkdown(urlMarkdown);

                  $scope.onUrlInserted({
                    url: scope.urlRef.Url,
                    title: scope.urlRef.TitleEN,
                    content: inputElement.value
                  });

                  modal.$promise.then(modal.hide);
                }
              }
            );
          };

          // Insert
          $scope.insert = function () {
            var supportedLookupAttributes = {};

            supportedLookupAttributes.GlossaryTerm = $scope.sectionBlockLookupAttributes.GlossaryTerm;

            var modal = modalService.displayTemplateModal(
              'Insert...',
              require('./referenceType/prcInlineReference.modal.tpl.html'),
              {
                canInsertBusinessUnit: !!$scope.onBusinessUnitInserted,
                canInsertCommittee: !!$scope.onCommitteeInserted,
                canInsertCorporateRole: !!$scope.onCorpRoleInserted,
                canInsertFootnote: !!$scope.onFootnoteInserted,
                canInsertGlossaryTerm: !!$scope.onGlossaryTermInserted,
                canInsertIAMSystem: !!$scope.onIAMSystemInserted,
                canInsertProcedure: !!$scope.onProcedureInserted,
                canInsertResponsibility: !!$scope.onResponsibilityInserted,
                lookupAttributes: $scope.sectionBlockLookupAttributes,
                onBusinessUnitSelection: function () {
                  modal.$promise.then(modal.hide);
                  addBusinessUnitReference();
                },
                onCommitteeSelection: function () {
                  modal.$promise.then(modal.hide);
                  addCommitteeReference();
                },
                onCorporateRoleSelection: function () {
                  modal.$promise.then(modal.hide);
                  addCorporateRoleReference();
                },
                onGlossaryTermSelection: function () {
                  modal.$promise.then(modal.hide);
                  addGlossaryTermReference();
                },
                onIAMSystemSelection: function () {
                  modal.$promise.then(modal.hide);
                  addIAMSystemReference();
                },
                onFootnoteSelection: function () {
                  modal.$promise.then(modal.hide);
                  addFootnote();
                },
                onResponsibilitySelection: function () {
                  modal.$promise.then(modal.hide);
                  addResponsibility();
                },
                onSectionSelection: function () {
                  modal.$promise.then(modal.hide);
                  addSectionReference();
                },
                onProcedureSelection: function () {
                  modal.$promise.then(modal.hide);
                  addProcedureReference();
                }
              },
              false
            );
          };

          function addBusinessUnitReference() {
            var modal = modalService.displayTemplateModal(
              'Select a Business Unit',
              require('./referenceType/prcBusinessUnit.modal.tpl.html'),
              {
                lang: $scope.lang,
                getDisplayValue: getDisplayValue,
                onSelectBusinessUnit: function (businessUnit) {
                  var markdown = getMarkdownForBusUnit(businessUnit);
                  insertNewMarkdown(markdown);

                  $scope.onBusinessUnitInserted({
                    businessUnit: businessUnit,
                    content: inputElement.value
                  });

                  modal.$promise.then(modal.hide);
                }
              },
              false
            );
          }

          function addCommitteeReference() {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            procedureService
              .getAllCommittees()
              .then(function (committees) {

                var modal = modalService.displayTemplateModal(
                  'Select a Committee',
                  require('./referenceType/prcCommittee.modal.tpl.html'),
                  {
                    availableCommittees: committees,
                    placeholderText: committees.length ? 'Select a Committee' : 'No available Committee',
                    ngStyle: {'min-height': '260px'},
                    selection: {
                      selectedCommittee: null
                    }
                  },
                  function (scope) {
                    if (scope.selection.selectedCommittee) {
                      window.scrollTo(0, curScroll);

                      var markdown = getMarkdownForCommittee(scope.selection.selectedCommittee);
                      insertNewMarkdown(markdown);

                      $scope.onCommitteeInserted({
                        committee: scope.selection.selectedCommittee,
                        content: inputElement.value
                      });

                      return true;
                    }
                  },
                  true,
                  function () {
                    window.scrollTo(0, curScroll);
                  }
                );

              })
          }

          function addCorporateRoleReference() {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            procedureService
              .getAllCorporateRoles()
              .then(function (corpRoles) {

                var modal = modalService.displayTemplateModal(
                  'Select a Corporate Role',
                  require('./referenceType/prcCorporateRole.modal.tpl.html'),
                  {
                    availableCorporateRoles: corpRoles,
                    placeholderText: corpRoles.length ?
                      'Select a Corporate Role' : 'No available Corporate Roles',
                    ngStyle: {'min-height': '260px'},
                    selection: {
                      selectedCorporateRole: null
                    }
                  },
                  function (scope) {
                    if (scope.selection.selectedCorporateRole) {
                      window.scrollTo(0, curScroll);

                      var markdown = getMarkdownForCorporateRole(scope.selection.selectedCorporateRole);
                      insertNewMarkdown(markdown);

                      $scope.onCorpRoleInserted({
                        corporateRole: scope.selection.selectedCorporateRole,
                        content: inputElement.value
                      });

                      return true;
                    }
                  },
                  true,
                  function () {
                    window.scrollTo(0, curScroll);
                  }
                );

              })
          }

          function addGlossaryTermReference() {
            var curScroll = window.pageYOffset;
            var lookupAttribute = $scope.sectionBlockLookupAttributes.GlossaryTerm;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            modalService.displayTemplateModal(
              lookupAttribute['Title' + $scope.lang],
              require('./referenceType/prcLookupAttributeValue.modal.tpl.html'),
              {
                lang: $scope.lang,
                availableLookupAttributeValues: lookupAttribute.LookupAttributeValues,
                selection: {
                  selectedLookup: null
                },
                getValueInLang: function (object, column, lang) {
                  if (_.isNil(object)) return '';

                  return _.get(object, column + lang, object[column + 'EN']);
                },
                ngStyle: {'min-height': '260px'},
                placeholderText: getLookupAttrValuePlaceholder(lookupAttribute)
              },
              function (scope) {
                if (scope.selection.selectedLookup) {
                  window.scrollTo(0, curScroll);
                  var markdown = getMarkdownForLookupAttrValue(
                    lookupAttribute,
                    scope.selection.selectedLookup);

                  insertNewMarkdown(markdown);

                  $scope.onGlossaryTermInserted({
                    glossaryTerm: scope.selection.selectedLookup,
                    content: inputElement.value
                  });
                  return true;
                }
              },
              true,
              function () {
                window.scrollTo(0, curScroll);
              }
            );
          }

          function addIAMSystemReference() {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            var modal = modalService.displayTemplateModal(
              'Select a IAM System',
              require('./referenceType/prcIAMSystem.modal.tpl.html'),
              {
                ngStyle: {
                  width: '55%'
                },
                lang: $scope.lang,
                onSelectIAMSystem: function (iamSystem) {
                  var markdown = getMarkdownForIAMSystem(iamSystem);
                  insertNewMarkdown(markdown);

                  $scope.onIAMSystemInserted({
                    iamSystem: iamSystem,
                    content: inputElement.value
                  });

                  modal.$promise.then(modal.hide);
                }
              },
              false
            );
          }

          function addFootnote() {
            modalService.displayTemplateModal(
              'Insert Footnote',
              require('./referenceType/prcFootnote.modal.tpl.html'),
              {
                selection: {
                  title: null,
                  text: null
                }
              },
              function (scope) {
                if (scope.selection.title && scope.selection.text) {
                  var markdown = getMarkdownForFootnote(scope.selection.title, scope.selection.text);

                  insertNewMarkdown(markdown, true);

                  $scope.onFootnoteInserted({
                    title: scope.selection.title,
                    text: scope.selection.text,
                    content: inputElement.value
                  });
                  return true;
                }
              }
            );
          }

          function addResponsibility() {
            procedureService
              .getMarkdownInfo(
                $scope.procedure.MetadataBlock.ProcedureType.Value,
                $scope.procedure.ProcedureID,
                inputElement.value)
              .then(function (markdownInfo) {
                var participants = getParticipants(markdownInfo);

                var modal = modalService.displayTemplateModal(
                  'Select a Responsibility',
                  require('./referenceType/prcAssignResponsibility.modal.tpl.html'),
                  {
                    participants: participants,
                    selection: {
                      title: null,
                      lang: $scope.lang
                    },
                    onCreateResponsibility: function () {
                      modal.$promise.then(modal.hide);
                      createNewResponsibility(participants);
                    },
                    onSelectResponsibility: function (responsibility) {
                      var markdown = getMarkdownForResponsibility(responsibility);
                      insertNewMarkdown(markdown);

                      $scope.onResponsibilityInserted({
                        responsibility: responsibility,
                        content: inputElement.value
                      });

                      modal.$promise.then(modal.hide);
                    }
                  },
                  false
                );
              });
          }

          function addSectionReference() {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            if (_.isUndefined($scope.procedure) && _.isUndefined($scope.procedure.ProcedureID)) return;

            procedureService
              .getSectionBlocks(
                $scope.procedure.MetadataBlock.ProcedureType.Value,
                $scope.procedure.ProcedureID)
              .then(function (sectionBlocks) {

                // Needed for ui-select to display the section
                _.each(sectionBlocks, function (section) {
                  if (!section.TitleEN) section.TitleEN = '';
                  if (!section.TitleFR) section.TitleFR = '';
                });

                var modal = modalService.displayTemplateModal(
                  'Select a Section',
                  require('./referenceType/prcSection.modal.tpl.html'),
                  {
                    lang: $scope.lang,
                    availableSections: sectionBlocks,
                    getDisplayValue: getDisplayValue,
                    selection: {
                      selectedSection: null
                    },
                    ngStyle: {'min-height': '265px'}
                  },
                  function (scope) {
                    if (scope.selection.selectedSection.SectionBlockID) {
                      var markdown = getMarkdownForSection(scope.selection.selectedSection);
                      insertNewMarkdown(markdown);

                      $scope.onSectionInserted({
                        section: scope.selection.selectedSection,
                        content: inputElement.value
                      });

                      window.scrollTo(0, curScroll);
                      modal.hide();
                    }
                  },
                  true,
                  function () {
                    window.scrollTo(0, curScroll);
                  }
                );
              });
          }

          function addProcedureReference() {
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            var modal = modalService.displayTemplateModal(
              'Select a Procedure',
              require('./referenceType/prcProcedure.modal.tpl.html'),
              {
                ngStyle: {
                  width: '55%'
                },
                lang: $scope.lang,
                selectProcedure: function (procedure) {
                  var procedureAlreadyReferenced = _.find($scope.sectionBlock.ProcedureReferences, {
                    ProcedureID: procedure.ProcedureID
                  });

                  if (procedure.ProcedureID !== $scope.sectionBlock.ProcedureID
                    && !procedureAlreadyReferenced) {

                    var markdown = getMarkdownForProcedure(procedure)
                    insertNewMarkdown(markdown);

                    $scope.onProcedureInserted({
                      procedure: procedure,
                      content: inputElement.value
                    });

                    window.scrollTo(0, curScroll);
                    modal.$promise.then(modal.hide);
                  }
                },
                selectSection: function (procedure) {

                  modal.$promise.then(modal.hide);

                  procedureService
                    .getSectionBlocks(
                      procedure.MetadataBlock.ProcedureType.Value,
                      procedure.ProcedureID)
                    .then(function (sectionBlocks) {

                      // Needed for ui-select to display the section
                      _.each(sectionBlocks, function (section) {
                        if (!section.TitleEN) section.TitleEN = '';
                        if (!section.TitleFR) section.TitleFR = '';
                      });

                      var modal = modalService.displayTemplateModal(
                        'Select a Section',
                        require('./referenceType/prcSection.modal.tpl.html'),
                        {
                          lang: $scope.lang,
                          availableSections: sectionBlocks,
                          selection: {
                            selectedSection: null
                          },
                          getDisplayValue: getDisplayValue,
                          ngStyle: {'min-height': '265px'}
                        },
                        function (scope) {
                          if (scope.selection.selectedSection.SectionBlockID) {
                            var markdown = getMarkdownForSection(scope.selection.selectedSection);
                            insertNewMarkdown(markdown);

                            $scope.onSectionInserted({
                              section: scope.selection.selectedSection,
                              content: inputElement.value
                            });

                            window.scrollTo(0, curScroll);
                            modal.hide();
                          }
                        },
                        true,
                        function () {
                          window.scrollTo(0, curScroll);
                        }
                      );

                    });
                }
              },
              false
            );
          }

          function getDisplayValue(object, prop, defaultNoSuffix) {
            if (!object) return;

            var translated = _.get(object, prop + $scope.lang, null);

            if ($scope.lang === 'EN') return translated;

            var defaultVal = null;

            // Can be null or '' if using ui-select
            if (!translated) {
              defaultVal = _.get(object, prop + (defaultNoSuffix ? '' : 'EN'), null);
            }

            // No translation but default value
            if (defaultVal) {
              translated = defaultVal;
            }

            return translated;
          }

          function createNewResponsibility(participants) {
            var participantArray = [];
            var curScroll = window.pageYOffset;

            // TODO: update ui-select to force to always display at bottom
            window.scrollTo(0, 0);

            _.forEach(participants.BusinessUnit, function (busUnit) {
              busUnit.type = 'Business Unit';
              participantArray.push(busUnit);
            });

            _.forEach(participants.Committee, function (committee) {
              committee.type = 'Committee';
              participantArray.push(committee);
            });

            _.forEach(participants.CorporateRole, function (corRole) {
              corRole.type = 'Corporate Role';
              participantArray.push(corRole);
            });

            var modal = modalService.displayTemplateModal(
              'Create a new Responsibility',
              require('./referenceType/prcCreateResponsibility.modal.tpl.html'),
              {
                participants: participantArray,
                selection: {
                  participant: null,
                  busUnitParticipant: null,
                  committeeParticipant: null,
                  corporateRoleParticipant: null,
                  titleEN: null
                },
                ngStyle: {'min-height': '260px'}
              },
              function (scope) {
                if (scope.selection.participant && scope.selection.titleEN) {
                  var responsibility = {
                    TitleEN: scope.selection.titleEN,
                    TitleFR: scope.selection.titleFR ? scope.selection.titleFR : null
                  };

                  if (scope.selection.busUnitParticipant) {
                    responsibility.BusinessUnitID = scope.selection.busUnitParticipant.BusinessUnitID;
                  } else if (scope.selection.committeeParticipant) {
                    responsibility.CommitteeID = scope.selection.committeeParticipant.CommitteeID;
                  } else if (scope.selection.corporateRoleParticipant) {
                    responsibility.CorporateRoleID =
                      scope.selection.corporateRoleParticipant.CorporateRoleID;
                  }

                  responsibilityService
                    .createResponsibility(responsibility)
                    .then(function (createdResponsibility) {
                      window.scrollTo(0, curScroll);
                      var markdown = getMarkdownForResponsibility(createdResponsibility);
                      insertNewMarkdown(markdown);

                      $scope.onResponsibilityInserted({
                        responsibility: createdResponsibility,
                        content: inputElement.value
                      });

                      modal.$promise.then(modal.hide);
                    });
                }
              },
              true,
              function () {
                window.scrollTo(0, curScroll);
              }
            );
          }

          /**
           * @returns {string|null} Selected text in the inputElement, null if none
           */
          function getSelectedText() {
            var selectedText = inputElement.value.substring(
              inputElement.selectionStart,
              inputElement.selectionEnd);

            return selectedText.length > 0 ? selectedText : null;
          }

          function getLookupAttrValuePlaceholder(lookupAttribute) {
            if ($scope.lang === 'FR') {
              return (lookupAttribute.LookupAttributeValues
                && lookupAttribute.LookupAttributeValues.length) ?
                'Veuillez choisir un ' + lookupAttribute.TitleFR
                : 'Aucun ' + lookupAttribute.TitleFR + ' disponible';
            }
            return (lookupAttribute.LookupAttributeValues
              && lookupAttribute.LookupAttributeValues.length) ?
              'Please select a ' + lookupAttribute.TitleEN
              : 'No ' + lookupAttribute.TitleEN + ' to select';
          }

          /**
           * Insert the provided markdown content in the editor.
           * @param newMarkdown {string} markdown to provide
           * @param skipSelectedText {boolean=false} true to insert the markdown at the end of the selected text
           *          (if any), instead of replacing it.
           */
          function insertNewMarkdown(newMarkdown, skipSelectedText) {
            var cursorStart = inputElement.selectionStart,
              cursorEnd = inputElement.selectionEnd;

            if (skipSelectedText) {
              cursorStart = cursorEnd;
            }

            // Use inputElement.value instead of sectionBlock.Content to avoid trimming the content
            inputElement.value = inputElement.value.substring(0, cursorStart)
              + newMarkdown
              + inputElement.value.substring(cursorEnd, inputElement.value.length);

            // Focus the field and select the inserted markdown
            var newCursorPos = cursorStart + newMarkdown.length;
            $timeout(function () {
              inputElement.setSelectionRange(cursorStart, newCursorPos);
              inputElement.focus();
            }, 0);

            // Un-select after a short period of time to prevent user from clearing the text
            $timeout(function () {
              inputElement.setSelectionRange(newCursorPos, newCursorPos);
            }, 1200);
          }

          function getMarkdownForImage(image, title) {
            return '![' + title + '](' + image.AttachmentExternalID + ' "' + title + '")';
          }

          function getMarkdownForBusUnit(businessUnit) {
            var text = getSelectedText() || businessUnit['Title' + $scope.lang] || businessUnit.TitleEN;

            return '[' + text + '](BusinessUnit:' + businessUnit.BusinessUnitID + ')';
          }

          function getMarkdownForCommittee(committee) {
            var text = getSelectedText() || committee.TitleEN;

            return '[' + text + '](Committee:' + committee.CommitteeID + ')';
          }

          function getMarkdownForCorporateRole(corporateRole) {
            var text = getSelectedText() || corporateRole.TitleEN;

            return '[' + text + '](CorporateRole:' + corporateRole.CorporateRoleID + ')';
          }

          function getMarkdownForLookupAttrValue(lookupAttr, lookupAttrValue) {
            var text = getSelectedText() || lookupAttrValue['Title' + $scope.lang] || lookupAttrValue.TitleEN;

            return '[' + text + '](' + lookupAttr.Code + ':' + lookupAttrValue.LookupAttributeValueID + ')';
          }

          function getMarkdownForFootnote(title, text) {
            return '[' + title + '](Footnote:' + text + ')';
          }

          function getMarkdownForIAMSystem(iamSystem) {
            var text = getSelectedText() || iamSystem.Name;
            return '[' + text + '](IAMSystem:' + iamSystem.IAMSystemID + ')';
          }

          function getMarkdownForResponsibility(responsibility) {
            var text = '';

            if ($scope.lang === 'FR') {
              text = getSelectedText() || responsibility.TitleFR;
              return '[' + text + '](Responsibility:' + responsibility.ResponsibilityID + ')';
            }

            text = getSelectedText() || responsibility.TitleEN;
            return '[' + text + '](Responsibility:' + responsibility.ResponsibilityID + ')';
          }

          function getMarkdownForSection(section) {
            var text = getSelectedText() || section[['Title' + $scope.lang]] || section.TitleEN;
            return '[' + text + '](Section:' + section.SectionBlockMasterID + ')';
          }

          function getMarkdownForProcedure(procedure) {
            var text = getSelectedText()
              || procedure.MetadataBlock['TitleHtml' + $scope.lang]
              || procedure.MetadataBlock.TitleHtmlEN;

            return '[' + text + '](Procedure:' + procedure.ProcedureID + ')';
          }

          function getMarkdownForUrl(url, title) {
            return '[' + title + '](' + url + ')';
          }

          function getParticipants(contentInfo) {
            var participants = {
              BusinessUnit: [],
              Committee: [],
              CorporateRole: []
            };

            // Business Unit
            _.each(contentInfo.BusinessUnitReferences, function (businessUnit) {
              participants.BusinessUnit.push(businessUnit);
            });

            // Committee
            _.each(contentInfo.CommitteeReferences, function (committee) {
              participants.Committee.push(committee);
            });

            // CorporateRole
            _.each(contentInfo.CorporateRoleReferences, function (corporateRole) {
              participants.CorporateRole.push(corporateRole);
            });

            return participants;
          }
        }]
    };
  }
})();
